import React, { useEffect, useState } from "react";
import { AutoComplete } from "primereact/autocomplete";
import citiesData from "../../cities/cities.json";
import MyGoogleMap from "../../components/MyGoogleMap";
import NavbarPag from "../../components/NavbarPag";
import { Any } from "react-spring";
import db from "../../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  runTransaction,
  doc,
  addDoc,
} from "firebase/firestore";
import { useData } from "../../contexts/DataContext";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "../../atoms/dropdown";
import Loading from "../../atoms/loading";
import Modal from "../../atoms/modal";
import { text } from "stream/consumers";

interface Option {
  value: string;
  label: string;
}

interface Data {
  doc: string;
  field: string;
  where: number;
}
const WorkOrder = () => {
  // Convertir el objeto a un array de opciones
  const ciudadesArray: Option[] = Object.entries(citiesData).map(
    ([key, value]) => ({
      value: key,
      label: value,
    })
  );

  const [errorOd, setErrorOd] = useState(true);
  const [day, setDay] = useState("");
  const [destinatario, setDestinatario] = useState("");
  const [direccion, setDireccion] = useState("");
  const [contacto, setContacto] = useState("");
  const [guia, setGuia] = useState("");
  const [bultos, setBultos] = useState("");
  const [kilos, setKilos] = useState("");
  const [alto, setAlto] = useState("");
  const [ancho, setAncho] = useState("");
  const [largo, setLargo] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [destino, setDestino] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [Centro_de_costos, setCentro_de_costos] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [titel, setTitel] = useState("");
  const [textButton, setTextButton] = useState("Cerrar");
  const [lastNumber, setLastNumber] = useState(0);
  const location = useLocation();

  const { rutInit, od } = useData();

  const navigate = useNavigate();
  useEffect(() => {
    if (rutInit === "") {
      navigate("/");
    }
  }, []);

  let lisState = ["INICIAL", "RETIRADO", "ENTREGADO", "NO ENTREGADO"];

  const isFloat = (value: string, field: string) => {
    if (!/^\d+(\.\d+)?$/.test(value)) {
      setMessage(
        `El campo ${field} solo permite números enteros o decimales con punto`
      );
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };

  const isInteger = (value: string, field: string) => {
    if (!/^\d+$/.test(value)) {
      setMessage(`El campo ${field} solo permite números enteros`);
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };

  const [odValue, setOdValue] = useState(od);
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    set: React.Dispatch<React.SetStateAction<string>>
  ) => {
    //console.log(event.target.value)
    set(event.target.value);
  };
  const empty = (value: string, field: string) => {
    if (value === "") {
      setMessage(`Valor requerido ${field}`);
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };
  const hasForbiddenCharacters = (value: string, field: string) => {
    if (/[\"'\+\-=]/.test(value)) {
      setMessage(
        `El campo ${field} no puede contener los caracteres: " ' + - =`
      );
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };
  const isValidLength = (
    value: string,
    min: number,
    max: number,
    field: string
  ) => {
    if (value.length < min || value.length > max) {
      setMessage(
        `El campo ${field} debe tener entre ${min} y ${max} caracteres`
      );
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };
  const crear = () => {
    const fieldLis = [
      { value: destinatario, text: "Destinatario" },
      { value: direccion, text: "Direccion" },
      { value: contacto, text: "Numero Contacto" },
      { value: bultos, text: "Bultos" },
      { value: kilos, text: "Kilos" },
      { value: alto, text: "Alto" },
      { value: ancho, text: "Ancho" },
      { value: observaciones, text: "Observaciones" },
      { value: ciudad, text: "Ciudad" },
      { value: destino, text: "Destino" },
      { value: Centro_de_costos, text: "Centro de costos" },
      { value: guia, text: "Guia" },
    ];
    for (let i in fieldLis) {
      if (
        fieldLis[i].text === "Observaciones" ||
        fieldLis[i].text === "Numero Contacto" ||
        fieldLis[i].text === "Centro de costos"
      ) {
        continue;
      }
      if (empty(fieldLis[i].value, fieldLis[i].text)) {
        return;
      }
    }
    for (let i in fieldLis) {
      if (
        fieldLis[i].text === "Observaciones" ||
        fieldLis[i].text === "Centro de costos"
      ) {
        if (fieldLis[i].value !== "") {
          if (hasForbiddenCharacters(fieldLis[i].value, fieldLis[i].text)) {
            return;
          }
        }
      } else if (fieldLis[i].text === "Numero Contacto") {
        if (fieldLis[i].value !== "") {
          if (isInteger(fieldLis[i].value, fieldLis[i].text)) {
            return;
          }
        }
      } else if (
        fieldLis[i].text === "Direccion" ||
        fieldLis[i].text === "Destinatario"
      ) {
        if (
          hasForbiddenCharacters(fieldLis[i].value, fieldLis[i].text) ||
          isValidLength(fieldLis[i].value, 2, 255, fieldLis[i].text)
        ) {
          return;
        }
      } else if (
        fieldLis[i].text === "Destino" ||
        fieldLis[i].text === "Ciudad"
      ) {
        continue;
      } else {
        if (isFloat(fieldLis[i].value, fieldLis[i].text)) {
          return;
        }
      }
    }
    getDate();
  };

  const [value, setValue] = useState("");
  const [value2, setValue2] = useState("");
  const [items, setItems] = useState<string[]>([]);
  const [items2, setItems2] = useState<string[]>([]);
  const [errorOC, setErrorOC] = useState(false);
  const [errorDC, setErrorDC] = useState(false);

  const citySet = (
    city: string,
    setCiudad: React.Dispatch<React.SetStateAction<string>>,
    setError: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    let data = ciudadesArray.filter((f) =>
      f.label.toUpperCase().startsWith(city.toUpperCase())
    );
    if (data.length < 1) {
      setError(true);
      setCiudad("");
    } else {
      setError(false);
      setCiudad("");
      data.sort((a, b) => a.label.length - b.label.length);
      setCiudad(data[0].value);
      //console.log(data[0]);
      //setCiudad(data[0].value);
      // console.log(data.length);
    }
    if (data.length === 1) {
      setCiudad(data[0].value);
    }
  };

  const search = (
    event: any,
    setItems: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    let data = ciudadesArray.filter((f) =>
      f.label.toUpperCase().startsWith(event.query.toUpperCase())
    );
    setItems([...data].map((item) => item.label));
  };

  const getDate = async () => {
    const uuidRef = doc(db, "uuid", "1");
    try {
      await runTransaction(db, async (transaction) => {
        const sfDoc = await transaction.get(uuidRef);

        let newPopulation = sfDoc.data()?.uuid;
        setLastNumber(newPopulation);
        console.log(newPopulation);
        if (await newOrders(newPopulation)) {
          newPopulation = newPopulation + 1;
          transaction.update(uuidRef, { id: 0, uuid: newPopulation });
        }
      });
      //console.log("Transaction successfully committed!");
    } catch (e) {
      //console.log("Transaction failed: ", e);
    }
  };
  const newOrders = async (newPopulation: number) => {
    setLoading(true);
    const ordersRef = collection(db, "orders");
    const deliveries = collection(db, "deliveries");
    const ordersxusersRef = collection(db, "ordersxusers");
    var options: any = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };

    const now = new Date().toLocaleDateString("es-ES", options).toUpperCase();
    //console.log("trace dia", now);

    const dia = now.split("GMT")[0];
    let textOrder: any = [[`${newPopulation}:${bultos}`]];
    let nunOr = 0;
    const timestam = new Date();
    const payload = {
      uuid: newPopulation,
      id: newPopulation,
      alto: alto,
      ancho: ancho,
      bultos: bultos,
      ciudad: ciudad,
      contacto: contacto,
      destinatario: destinatario,
      direccion: direccion,
      email: location.state.email,
      guia: guia,
      kilos: kilos,
      largo: largo,
      observaciones: observaciones,
      fecha: dia,
      Destino: destino,
      time: timestam,
      Centro_de_costos: Centro_de_costos,
    };
    const timestamp = new Date().getTime();
    const payload2 = {
      uuid: newPopulation,
      fecha: timestamp,
      fechaReceived: 0,
      Destino: destino,
      state: 0,
      receivingStatus: 0,
      bultos: bultos,
      receivingBultos: 0,
      email: location.state.email,
    };
    addDoc(ordersRef, payload);
    addDoc(deliveries, payload2);
    addDoc(ordersxusersRef, { email: location.state.email, fecha: dia });
    setDay(dia);
    const q = query(
      collection(db, "listClientNumberOrder"),
      where("email", "==", location.state.email)
    );
    //console.log(location.state.email);
    const numberOfOrder = await getDocs(q);
    //console.log("numberOfOrder:", numberOfOrder);
    const info: any = [];
    numberOfOrder.forEach((doc) => {
      info.push({ data: doc.data(), id: doc.id });
    });
    if (info.length !== 0) {
      const refOfOrder = doc(db, "listClientNumberOrder", info[0].id);
      //updateDoc(refOfOrder, { numero: info[0].data.numero + orders.length });
      try {
        await runTransaction(db, async (transaction) => {
          const sfDoc = await transaction.get(refOfOrder);
          const newUmber = sfDoc.data()?.numero + 1;
          transaction.update(refOfOrder, {
            numero: newUmber,
          });
        });
        //console.log("Transaction successfully committed!");
      } catch (e) {
        //console.log("Transaction failed: ", e);
      }
    }
    if (textOrder.length !== 0) {
      console.log("textOrder*********", textOrder);
      for (let i = 0; i < textOrder.length; i++) {
        const jsonString = JSON.stringify(textOrder[i]);
        //console.log("****************");
        //console.log(textOrder[i][0].split(":")[0]);
        //console.log(textOrder[i][textOrder[i].length - 1].split(":")[0]);
        //console.log(textOrder[i].length);
        //console.log(location.state.email);
        //console.log(jsonString);
        const lisOrders = collection(db, "lisOrders");
        addDoc(lisOrders, {
          email: location.state.email,
          in: Number(textOrder[i][0].split(":")[0]),
          fi: Number(textOrder[i][textOrder[i].length - 1].split(":")[0]),
          text: jsonString,
        });
      }
    }

    setLoading(false);
    setMessage(`Orden ${newPopulation} creada`);
    setTitel("Orden creada");
    setShowModal(true);
    setDestinatario("");
    setDireccion("");
    setCentro_de_costos("");
    setContacto("");
    setBultos("");
    setKilos("");
    setAlto("");
    setAncho("");
    setLargo("");
    setObservaciones("");
    setGuia("");

    return true;
  };

  const getCity = (data: string, label: string) => {
    console.log("label", label, "label", data);
    const datas = data.split(":");
    console.log(datas);
    if (label === "Ciudad de Origen") {
      setCiudad(datas[0]);
    } else {
      setDestino(datas[0]);
    }
  };
  return (
    <div className={errorOd ? "w-screen h-screen" : ""}>
      {showModal && (
        <Modal
          message={message}
          titel={titel}
          onClick={() => {
            setShowModal(false);

            if (titel === "Orden creada") {
              console.log(titel);
              navigate("/search", {
                state: {
                  email: location.state.email,
                  name: location.state.name,
                  day: day,
                },
              });
            }
          }}
          textButton={textButton}
        />
      )}
      {/* Loader */}
      {loading && <Loading />}
      {/* navbar */}
      <NavbarPag />
      <div className=" h-full bg-neutral-200 overflow-hidden flex flex-col items-center">
        <div className=" w-11/12">
          <h2 className="text-2xl text-center p-3">Crear orden</h2>
          <div className="bg-sky-600 p-2 text-white">Ingresa datos</div>

          <article className=" bg-slate-50">
            <div className="flex p-4">
              <div>
                <label
                  htmlFor="dropdown-select"
                  className="block font-medium text-gray-700"
                >
                  Ciudad de Origen
                </label>
                <AutoComplete
                  className="w-64 mr-4"
                  inputClassName="bg-gray-700 border border-gray-600 text-white text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 w-full"
                  panelClassName="bg-gray-800 border border-gray-600 rounded-lg mt-1 shadow-md text-white dark:text-white"
                  value={value}
                  suggestions={items}
                  completeMethod={(e) => search(e, setItems)}
                  onChange={(e) => {
                    setValue(e.value);
                    citySet(e.value, setCiudad, setErrorOC);
                  }}
                  dropdown
                  onSelect={(e) => {
                    citySet(e.value, setCiudad, setErrorOC);
                  }}
                />
                {errorOC ? (
                  <label
                    htmlFor="dropdown-select"
                    className="block font-medium text-gray-700 text-red-500"
                  >
                    Error Ciudad no encontrada
                  </label>
                ) : (
                  ""
                )}
              </div>

              <div>
                <label
                  htmlFor="dropdown-select"
                  className="block font-medium text-gray-700"
                >
                  Ciudad de destino
                </label>
                <AutoComplete
                  className="w-64 mr-4"
                  inputClassName="bg-gray-700 border border-gray-600 text-white text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 w-full"
                  panelClassName="bg-gray-800 border border-gray-600 rounded-lg mt-1 shadow-md text-white dark:text-white"
                  value={value2}
                  suggestions={items2}
                  completeMethod={(e) => search(e, setItems2)}
                  onChange={(e) => {
                    setValue2(e.value);
                    citySet(e.value, setDestino, setErrorDC);
                  }}
                  dropdown
                  onSelect={(e) => {
                    citySet(e.value, setDestino, setErrorDC);
                  }}
                />
                {errorDC ? (
                  <label
                    htmlFor="dropdown-select"
                    className="block font-medium text-gray-700 text-red-500"
                  >
                    Error Ciudad no encontrada
                  </label>
                ) : (
                  ""
                )}
              </div>
              <div>
                <label
                  htmlFor="dropdown-select"
                  className="block font-medium text-gray-700 pt-6"
                ></label>
                <input
                  type="text"
                  placeholder="Guia"
                  value={guia} // Asignar el valor del estado al input
                  onChange={(event) => handleInputChange(event, setGuia)}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
                />
              </div>
            </div>
            <div className="flex p-4">
              <input
                type="text"
                placeholder="Destinatario"
                value={destinatario} // Asignar el valor del estado al input
                onChange={(event) => handleInputChange(event, setDestinatario)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
              />
              <input
                type="text"
                placeholder="Direccion"
                value={direccion} // Asignar el valor del estado al input
                onChange={(event) => handleInputChange(event, setDireccion)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
              />
              <input
                type="text"
                placeholder="Centro de costos"
                value={Centro_de_costos} // Asignar el valor del estado al input Centro_de_costos
                onChange={(event) =>
                  handleInputChange(event, setCentro_de_costos)
                }
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
              />
            </div>

            <div className="flex p-4">
              <input
                type="text"
                placeholder="Bultos"
                value={bultos} // Asignar el valor del estado al input
                onChange={(event) => handleInputChange(event, setBultos)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
              />
              <input
                type="text"
                placeholder="Kilos"
                value={kilos} // Asignar el valor del estado al input
                onChange={(event) => handleInputChange(event, setKilos)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
              />
              <input
                type="text"
                placeholder="Alto"
                value={alto} // Asignar el valor del estado al input
                onChange={(event) => handleInputChange(event, setAlto)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
              />
            </div>

            <div className="flex p-4">
              <input
                type="text"
                placeholder="Ancho"
                value={ancho} // Asignar el valor del estado al input
                onChange={(event) => handleInputChange(event, setAncho)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
              />
              <input
                type="text"
                placeholder="Largo"
                value={largo} // Asignar el valor del estado al input
                onChange={(event) => handleInputChange(event, setLargo)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
              />
              <input
                type="text"
                placeholder="Numero Contacto"
                value={contacto} // Asignar el valor del estado al input
                onChange={(event) => handleInputChange(event, setContacto)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
              />
            </div>

            <div className="flex p-4">
              <input
                type="text"
                placeholder="Observaciones"
                value={observaciones} // Asignar el valor del estado al input
                onChange={(event) => handleInputChange(event, setObservaciones)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-3/6 mr-4"
              />
            </div>
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-10 mb-5"
              onClick={crear}
            >
              Crear
            </button>
          </article>
        </div>
      </div>
    </div>
  );
};

export default WorkOrder;
